import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ToolTipIcon from '../../../components/ToolTipIcon/ToolTipIcon';
import { getPermissions } from '../../../utils/getPermissions';

function DashboardActions(props) {
  const { auth, onDownload } = props;
  const p = getPermissions(auth);

  if (!p.atLeastTierProOrSuperUser) {
    return null;
  }

  return (
    <div
      data-test="dashboard-actions"
      className="grid grid-cols-[repeat(5,_max-content)] md:grid-cols-[repeat(7,_max-content)] xl:grid-cols-[repeat(14,_max-content)] gap-2 mt-2"
    >
      <ToolTipIcon toolText="Download Devices Report">
        <button
          type="button"
          data-test="dashboard-download-report-button"
          onClick={onDownload}
          className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
        >
          <img
            src="/assets/images/icons/dashboard_download.png"
            alt="Delete"
            className="w-[30px] h-[30px]"
            draggable={false}
          />
        </button>
      </ToolTipIcon>
    </div>
  );
}

DashboardActions.propTypes = {
  auth: PropTypes.shape({
    user: PropTypes.shape({
      permissions: PropTypes.shape({
        writer: PropTypes.bool,
      }),
    }),
  }).isRequired,
  onDownload: PropTypes.func.isRequired,
};
const mapDispatchToProps = {};
const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardActions);
